
const m = window.require("@floating-ui/dom");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
